module.exports = __webpack_public_path__ + "static/media/faq-mic.d4b188e5.svg";